import { useState } from "react";
import GridSavedState from "./UseLocalStorageGridState";

const useSavedState = <T,>(key: string, initialState: T) => {
  const [savedState] = GridSavedState<T>(key, initialState);
  return useState<T>(savedState);
};
export default useSavedState;
